// --------------------------------------------
// Constants to be used in actions and reducers
// ---------------------------------------------
const PREFIX = 'KardiaRx.';
export const CCT_PATIENTS_DATA_REQUEST = `${PREFIX}CCT_PATIENTS_DATA_REQUEST`;
export const CCT_PATIENTS_DATA_SUCCESS = `${PREFIX}CCT_PATIENTS_DATA_SUCCESS`;
export const CCT_PATIENTS_DATA_FAILURE = `${PREFIX}CCT_PATIENTS_DATA_FAILURE`;
export const CCT_PATIENTST_FILTER_DROPDOWN_VALUE_SUBMIT = `${PREFIX}CCT_PATIENTST_FILTER_DROPDOWN_VALUE_SUBMIT`;
export const CCT_PATIENTST_CLEAR_PAGELIMIT = `${PREFIX}CCT_PATIENTST_CLEAR_PAGELIMIT`;

export const CCT_ECG_TABLE_DATA_REQUEST = `${PREFIX}CCT_ECG_TABLE_DATA_REQUEST`;
export const CCT_ECG_TABLE_DATA_SUCCESS = `${PREFIX}CCT_ECG_TABLE_DATA_SUCCESS`;
export const CCT_ECG_TABLE_DATA_FAILURE = `${PREFIX}CCT_ECG_TABLE_DATA_FAILURE`;
export const CCT_SELECTED_PATIENT = `${PREFIX}CCT_SELECTED_PATIENT`;
export const CCT_SELECTED_RECORDING = `${PREFIX}CCT_SELECTED_RECORDING`;
export const CCT_PATIENT_Provider_Id_UPDATE = `${PREFIX}CCT_PATIENT_Provider_Id_UPDATE`;
export const CCT_PATIENT_Practice_Id_UPDATE = `${PREFIX}CCT_PATIENT_Practice_Id_UPDATE`;
export const CCT_PATIENT_SELECTED_VALUE_ON_SUBMIT_CLEAR = `${PREFIX}CCT_PATIENT_SELECTED_VALUE_ON_SUBMIT_CLEAR`;



// WEBPACK FOOTER //
// ./src/views/state/KardiaRxCCTPatient/types.js